export function planMuseum(artists){
 const bays=[],works=[];let index=0;
 for(const artist of artists){
  for(let offset=0;offset<artist.artworks.length;offset+=6){
   const side=index%2===0?-1:1,z=18+Math.floor(index/2)*10;
   const bay={id:`${artist.id}:${offset}`,artist,side,z,index,works:[]};
   artist.artworks.slice(offset,offset+6).forEach((art,j)=>{
    // Three on the long exterior wall; three on the rear partition.
    const p=j<3?[side*11.84,1.95,z-3+j*2.8]:[side*(4.5+(j-3)*2.6),1.95,z+4.84];
    const rotation=j<3?-side*Math.PI/2:Math.PI;
    const slot={...art,position:p,rotation,bay:index,visit:[side*7,1.65,z]};
    bay.works.push(slot);works.push(slot);
   });bays.push(bay);index++;
  }
 }
 return {bays,works,length:20+Math.ceil(index/2)*10};
}
export function artworkSize(art,aspect=1){
 let w=Number(art.width_cm)/100,h=Number(art.height_cm)/100;
 if(!(w>0&&h>0)){const m=String(art.size||'').match(/([\d.]+)\s*[×x]\s*([\d.]+)\s*cm/i);if(m){w=Number(m[1])/100;h=Number(m[2])/100;}}
 if(!(w>0&&h>0)){h=1.05;w=h*aspect;}
 const fit=Math.min(1,2.1/w,2.6/h);return [w*fit,h*fit];
}
